import React from "react";

import FileService from "services/file";

import ZeeExplorer from "components/ZeeExplorer";

export default class extends React.Component {
  fileService = new FileService();

  state = {
    data: null,
  };

  constructor() {
    super(...arguments);
    this.fileService.getAll().then(({ data }) => this.setState(data));
  }

  async onDelete(file) {
    const result = await this.fileService.delete(file).then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  async onEdit(file) {
    const result = await this.fileService.update(file).then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  async onFileUpload(file, original, onProgress) {
    const form = new FormData();
    Object.keys(file).forEach((key) => form.append(key, file[key]));
    form.append("file", original);
    const config = {
      onUploadProgress: function (progressEvent) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(file, progress);
      },
      headers: { "Content-Type": "multipart/form-data" },
    };

    const result = await this.fileService
      .create(form, config)
      .then(({ data }) => data);

    if (result.success) {
      return result.data;
    }

    return false;
  }

  async onCreateFolder(folder) {
    const result = await this.fileService
      .create(folder)
      .then(({ data }) => data);
    if (result.success) {
      return result.data;
    }
    return false;
  }

  render() {
    const { data } = this.state;

    const hasDataLoaded = data ? true : false;
    if (hasDataLoaded) {
      return (
        <ZeeExplorer
          data={data}
          onCreateFolder={(folder) => this.onCreateFolder(folder)}
          onEdit={(file) => this.onEdit(file)}
          onDelete={(file) => this.onDelete(file)}
          onFileUpload={(file, original, onProgress) =>
            this.onFileUpload(file, original, onProgress)
          }
        />
      );
    }

    return <p>Loading data</p>;
  }
}
